import { css as cssClassName } from 'emotion';
import React from 'react';
import { Button } from 'shared/Button/NewButton';
import { Modal } from '@spotify-internal/anchor-ds';

export enum ModalActions {
  DELETE_QUESTION = 'DELETE_QUESTION',
  BLOCK_USER = 'BLOCK_USER',
}

export function ConfirmationModal({
  onCancel,
  onConfirm,
  action,
}: {
  onCancel: () => void;
  onConfirm: () => void;
  action: ModalActions;
}) {
  if (!action) return null;
  const actionText =
    action === ModalActions.DELETE_QUESTION
      ? 'delete this question'
      : 'block this user';
  return (
    <Modal
      isShowing
      isShowingCloseButton
      aria-labelledby="confirmation-interactive-question-title"
      onClose={onCancel}
    >
      <Modal.Title id="confirmation-interactive-question-title">
        Are you sure you want to {actionText}?
      </Modal.Title>
      <Modal.Body>{getModalCopy(action)}</Modal.Body>
      <Modal.Footer>
        <Button type="button" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          className={cssClassName`margin-left: 16px;`}
          kind="button"
          type="button"
          color="purple"
          onClick={onConfirm}
        >
          Yes, {actionText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function getModalCopy(action: ModalActions) {
  switch (action) {
    case ModalActions.DELETE_QUESTION:
      return "If you delete this question, we won't be able to recover it.";
    case ModalActions.BLOCK_USER:
      return 'This user will no longer be able to respond to any questions.';
    default:
      return null;
  }
}
